export default __webpack_public_path__ + "static/media/most-popular-artwork-2.005d94b8.png";